import { RootSchema } from "../../../redux/reducers";
import { AnalyticsEvent } from "../types";
import { mapStaticMutation } from "./helpers";

export const mapBrandingAnalyticsEvents = (previousState: RootSchema, currentState: RootSchema): AnalyticsEvent[] => [
  ...mapStaticMutation(previousState.deployment?.saveCustomDomain, currentState.deployment?.saveCustomDomain, {
    successEventName: "branding_custom_domain_added",
    errorEventName: "branding_custom_domain_got_error"
  }),
  ...mapStaticMutation(previousState.deployment?.deleteCustomDomain, currentState.deployment?.deleteCustomDomain, {
    successEventName: "branding_custom_domain_deleted",
    errorEventName: "branding_custom_domain_got_error"
  }),
  ...mapStaticMutation(previousState.customDomainMapping, currentState.customDomainMapping, {
    errorEventName: "branding_custom_domain_got_error",
    trackedEventNames: ["branding_custom_domain_mapping_updated", "branding_custom_domain_mapping_removed", "branding_custom_domain_got_error"]
  }),
  ...mapStaticMutation(previousState.deployment?.emailTemplateMutation, currentState.deployment?.emailTemplateMutation, {
    errorEventName: "branding_email_template_got_error",
    trackedEventNames: ["branding_email_template_created", "branding_email_template_updated", "branding_email_template_deleted", "branding_email_template_reset", "branding_email_template_got_error"]
  }),
  ...mapStaticMutation(previousState.deployment?.generateEmailTemplateAI, currentState.deployment?.generateEmailTemplateAI, {
    errorEventName: "branding_email_ai_flow_got_error",
    trackedEventNames: ["branding_email_ai_flow_initiated", "branding_email_ai_flow_got_error"]
  }),
  ...mapStaticMutation(previousState.deployment?.saveEmailSettings, currentState.deployment?.saveEmailSettings, {
    successEventName: "branding_email_template_settings_saved",
    errorEventName: "branding_email_template_got_error"
  }),
  ...mapStaticMutation(previousState.deployment?.sendTestEmail, currentState.deployment?.sendTestEmail, {
    successEventName: "branding_email_provider_tested",
    errorEventName: "branding_email_provider_got_error"
  }),
  ...mapStaticMutation(previousState.deployment?.smtpSetting, currentState.deployment?.smtpSetting, {
    errorEventName: "branding_email_provider_got_error",
    trackedEventNames: [
      "branding_email_provider_created",
      "branding_email_provider_updated",
      "branding_email_provider_deleted",
      "branding_email_provider_set_default",
      "branding_email_provider_got_error"
    ]
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.saveSMSConfigResponse, currentState.platformConfiguration?.saveSMSConfigResponse, {
    errorEventName: "branding_sms_provider_got_error",
    trackedEventNames: ["branding_sms_provider_created", "branding_sms_provider_updated", "branding_sms_provider_got_error"]
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.saveCustomSMSConfigResponse, currentState.platformConfiguration?.saveCustomSMSConfigResponse, {
    errorEventName: "branding_sms_provider_got_error",
    trackedEventNames: ["branding_sms_provider_created", "branding_sms_provider_updated", "branding_sms_provider_deleted", "branding_sms_provider_got_error"]
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.resetSMSConfigResponse, currentState.platformConfiguration?.resetSMSConfigResponse, {
    successEventName: "branding_sms_provider_reset",
    errorEventName: "branding_sms_provider_got_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.saveGlobalSMSSettingsResponse, currentState.platformConfiguration?.saveGlobalSMSSettingsResponse, {
    successEventName: "branding_sms_template_settings_saved",
    errorEventName: "branding_sms_template_got_error",
    trackedEventNames: [
      "branding_sms_template_created",
      "branding_sms_template_updated",
      "branding_sms_template_deleted",
      "branding_sms_template_reset",
      "branding_sms_template_settings_saved",
      "branding_sms_template_got_error"
    ]
  }),
  ...mapStaticMutation(previousState.deployment?.progressiveProfilingData, currentState.deployment?.progressiveProfilingData, {
    errorEventName: "branding_forms_got_error",
    trackedEventNames: [
      "branding_forms_saved_registration",
      "branding_forms_created_progressive_profiling_step",
      "branding_forms_updated_progressive_profiling_step",
      "branding_forms_deleted_progressive_profiling_step",
      "branding_forms_got_error"
    ]
  }),
  ...mapStaticMutation(previousState.auth?.updateAppBasicInfo, currentState.auth?.updateAppBasicInfo, {
    trackedEventNames: ["branding_js_widget_saved_settings"]
  })
];
